import { createContext } from "react";
const ContainerContext = createContext({
  containerStyle: {},
  title: {},
});
export default ContainerContext;
